import { render, staticRenderFns } from "./PromoProduct.vue?vue&type=template&id=1b1ae388&scoped=true&"
import script from "./PromoProduct.vue?vue&type=script&lang=js&"
export * from "./PromoProduct.vue?vue&type=script&lang=js&"
import style0 from "./PromoProduct.vue?vue&type=style&index=0&id=1b1ae388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ae388",
  null
  
)

export default component.exports